<app-portfolio-filter-section (updatedFilters)="receiveUpdatedFilters($event)"></app-portfolio-filter-section>
<app-company-assignments-portfolio-user 
[pagedCompanyAssignments]="myCompanyPortfolioAssignations$ | async"
(markCompanyAsFavorite)="receiveCompanyToMarkAsFavorite($event)"
(unmarkCompanyAsFavorite)="receiveCompanyToUnmarkAsFavorite($event)"
(changePagination)="receivePaginationClients($event)">
</app-company-assignments-portfolio-user>